import "../../assets/css/card-types.css";
import React from "react";
import CheckCardTypeIcon from "./CheckCardTypeIcon";

export function CreditCardTypes(props) {
  const { activeType } = props;

  return (
    <div className="form-group cc-types">
      <div
        className={
          "cc-type cc-type--amex js-cc-type--amex " + (activeType === "AMEX" ? "active" : "")
        }>
        <CheckCardTypeIcon ccType="AMEX" />
      </div>
      <div
        className={
          "cc-type cc-type--visa js-cc-type--visa " + (activeType === "VISA" ? "active" : "")
        }>
        <CheckCardTypeIcon ccType="VISA" />
      </div>
      <div
        className={
          "cc-type cc-type--mast js-cc-type--mast " + (activeType === "MAST" ? "active" : "")
        }>
        <CheckCardTypeIcon ccType="MAST" />
      </div>
      <div
        className={
          "cc-type cc-type--dscv js-cc-type--dscv " + (activeType === "DSCV" ? "active" : "")
        }>
        <CheckCardTypeIcon ccType="DSCV" />
      </div>
    </div>
  );
}

export default CreditCardTypes;
